export const ERROR = {
	CODES: {
		UNAUTHORIZED: 401,
	},
};
